var map = {
	"./en": "../../node_modules/@vue-devtools/app-frontend/src/locales/en.js",
	"./en.js": "../../node_modules/@vue-devtools/app-frontend/src/locales/en.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../node_modules/@vue-devtools/app-frontend/src/locales sync recursive ^\\.\\/.*$";